import React from 'react';
import Icon from './Icon';

const LandmarkIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 3L2 8H22ZM6 8V17M10 8V17M14 8V17M18 8V17M4 21V17H20V21M2 21H22"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default LandmarkIcon;
